module.exports = __webpack_public_path__ + "img/brand-16.e297eafc.png";